import { Injectable } from "@angular/core";
import * as SecureLS from "secure-ls";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private ls = new SecureLS({ encodingType: "aes" });  
  clearIntval: any;
  notificationIntval: any;
  constructor() {}

  getRole(): number {
    if (window.location.href.indexOf("impersonate") == -1) {
      return this.ls.get("role");
    } else {
      return this.ls.get("impersonate_role");
    }
  }

  getImpersonateTextForUrl(): string {
    if (window.location.href.indexOf("impersonate") == -1) {
      return '';
    } else {
      return 'impersonate';
    }
  }

  getHod(): number {
    if (window.location.href.indexOf("impersonate") == -1) {
      return parseInt(this.ls.get("hod"));
    } else {
      return Boolean(this.ls.get("impersonate_hod")) ? 1 : 0;
    }
  }

  getDepartment(): any {
    if (window.location.href.indexOf("impersonate") == -1) {
      return this.ls.get("department_id");
    } else {
      return this.ls.get("impersonate_department_id");
    }
  }

  getProfessor(): any {
    if (window.location.href.indexOf("impersonate") == -1) {
      return this.ls.get("user_id");
    } else {
      return this.ls.get("impersonate_user_id");
    }
  }

  getCreatedBy(): any {
    if (window.location.href.indexOf("impersonate") == -1) {
      return this.ls.get("createdBy");
    } else {
      return this.ls.get("impersonate_createdBy");
    }
  }

  getCurrentSession(sessionData): any {
    let currentDate: any = new Date();
    let findedData: any;
    if (sessionData?.length) {
      findedData = sessionData.find((list) => {
        var from = new Date(list.start_date);
        var to = new Date(list.end_date);
        var check = new Date(
          `${currentDate.getFullYear()}-${
            Number(currentDate.getMonth()) + 1
          }-${currentDate.getDate()} 05:30:00`
        );

        return check >= from && check <= to;
      });
      return findedData;
    } else {
      return null;
    }
  }
}
